const OFFER_STRIP_PREFIX = "offer_strip";

export const OFFER_STRIP_TEST_IDS = {
    TEXT: `${OFFER_STRIP_PREFIX}_text`,
    CONTAINER: `${OFFER_STRIP_PREFIX}_container`,
    STATIC_IMAGE: `${OFFER_STRIP_PREFIX}_static_image`,
};
